import { render, staticRenderFns } from "./ProFormaInvoiceForm.vue?vue&type=template&id=5fd816e0"
import script from "./ProFormaInvoiceForm.vue?vue&type=script&lang=js"
export * from "./ProFormaInvoiceForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports